import { Box, Breadcrumbs, Container, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

// components
import ActionFooter from "../../components/ActionFooter";
import FullScreenLoading from "../../components/FullScreenLoading";
import BaseInfo from "../../components/category/BaseInfo";

// api
import { CategoryApi } from "../../api/CategoryApi";
import { StoreApi } from "../../api/StoreApi";

export default function Create() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [data, setData] = useState({
    name: "",
    description: "",
    images: [],
    appliedStores: [],
    priority: 0,
    showOnPos: true,
    showOnOrdering: true,
  });
  const [fullScreenLoading, setFullScreenLoading] = useState(false);
  const [storesList, setStoresList] = useState([]);

  useEffect(() => {
    fetchStoresList();
  }, []);

  const onSubmit = async () => {
    try {
      if (!data.name) {
        toast.error(t("error.please_enter_all_required_fields"));
        return;
      }
      setFullScreenLoading(true);
      const id = await CategoryApi.create(data);
      if (id) {
        toast.success(t("layout.created_successfully"));
        navigate(`/category`);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setFullScreenLoading(false);
    }
  };

  const fetchStoresList = async () => {
    try {
      setFullScreenLoading(true);
      const response = await StoreApi.list(1, -1, []);

      if (response.data) {
        setStoresList(response.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setFullScreenLoading(false);
    }
  };

  const onCancel = () => {
    navigate(-1);
  };

  return (
    <Container maxWidth="false">
      <FullScreenLoading open={fullScreenLoading} />
      <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 1 }}>
        <Link to={"/category"}>{t("menu.category")}</Link>
        <Typography color="text.primary">{t("layout.create")}</Typography>
      </Breadcrumbs>
      <Box component="form">
        <BaseInfo data={data} setData={setData} storesList={storesList} />
        <Box sx={{ my: 8 }} />
        <ActionFooter onSubmit={onSubmit} onCancel={onCancel} />
      </Box>
    </Container>
  );
}
